import React, { useEffect, useState } from 'react';

import {
    Badge,
    Box,
    Typography,
} from '@mui/material';

import apiClient from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import DynamicTable from '../../../components/Table/DataTable';
import { IconActivate, IconEdit, IconEye, IconHeart, IconPaw, IconShield } from '../../../components/icons/icons';
import TablePaginationActions from '../../../components/Table/tablePagination';
import LoadingScreen from '../../../components/LoadingScreen';
import WishlistDialog from '../../Products/WishListPage';
import { styled } from '@mui/system';
import SecurityDialog from '../SecurityDialog';

import { StatusModal } from '../ConfirmModal';
import LocationDialog from '../Locationmodal';
import AddOwnerModal from './AddOwnerModal';
import EditChoiceDialog from '../EditChoiceDialog';

export const STATUS = {
    ACTIVE: 1,
    INACTIVE: 2,
    DEACTIVATED: 0,
};


const AnimatedBox = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
        transform: 'scale(1.1)',
        boxShadow: `0 0 10px rgba(255, 0, 0, 0.4)`,
    },
    '&.active': {
        animation: 'pulse 1s infinite',
        '@keyframes pulse': {
            '0%': {
                transform: 'scale(1)',
            },
            '50%': {
                transform: 'scale(1.1)',
            },
            '100%': {
                transform: 'scale(1)',
            },
        },
    },
}));
const PetOwnerList = () => {
    const [owners, setOwners] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const [totalCount, setTotalCount] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [hasSearched, setHasSearched] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [petCounts, setPetCounts] = useState<Record<number, number>>({});
    const [statusFilter, setStatusFilter] = useState('');
    const [wishlistDialogOpen, setWishlistDialogOpen] = useState(false);
    const [selectedUsername, setSelectedUsername] = useState<string | null>(null);
    const [wishlistCounts, setWishlistCounts] = useState<Record<string, number>>({});
    const [securityDialogOpen, setSecurityDialogOpen] = useState(false);
    const [selectedUserForSecurity, setSelectedUserForSecurity] = useState<any>(null);
    const [locationDialogOpen, setLocationDialogOpen] = useState(false);
    const [selectedUserForLocation, setSelectedUserForLocation] = useState<any>(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [currentUser, setCurrentUser] = useState<any>(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editChoiceOpen, setEditChoiceOpen] = useState(false);
    const [selectedUserForEdit, setSelectedUserForEdit] = useState<any>(null);
    const fetchOwners = async () => {
        try {
            setLoading(true);

            const params: any = {
                limit: rowsPerPage,
                page: page + 1,
                searchkey: searchQuery || "",
                order_by: "id",
                dir: 2,
                type: "all",
                from: "",
                to: "",
            };

            if (statusFilter !== "") {
                params.isActiveUsers = statusFilter;
            }

            const queryString = new URLSearchParams(params).toString();
            const { data } = await apiClient(`v1/resource/patient?${queryString}`, { method: "GET" }) as any;

            const ownersData = data.patients;

            setOwners(ownersData);
            setTotalCount(data.pagination.total);

            // Fetch pet counts
            const ownerIds = ownersData.map((owner: { id: any }) => owner.id).filter(Boolean);
            if (ownerIds.length > 0) {
                await fetchPetCountsForOwners(ownerIds);
            }

        } catch (err: any) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const handleAddClick = () => {
        setShowAddModal(true);
    };
    const handleEditClick = (row: any) => {
        setSelectedUserForEdit(row);
        setEditChoiceOpen(true);
    };
    const handleOpenEditUser = () => {
        setEditData(selectedUserForEdit);
        setShowAddModal(true);
    };
    const handleOpenEditLocation = () => {
        setSelectedUserForLocation(selectedUserForEdit.user);
        setLocationDialogOpen(true);
    };
    useEffect(() => {
        fetchOwners();
    }, [searchQuery, statusFilter, page, rowsPerPage]);

    useEffect(() => {
        const fetchWishlistCounts = async () => {
            const usernames = owners.map((owner: any) => owner?.user?.username).filter(Boolean);

            const promises = usernames.map(async (username) => {
                try {
                    const res = await fetch(
                        `https://shop.petsync.in/wp-json/yithwishlist/v1/get?secret_key=83fef8ec35f37968a9b684a5c400a54a&username=${username}`
                    );
                    const data = await res.json();
                    return { username, count: data?.wishlist?.length || 0 };
                } catch {
                    return { username, count: 0 };
                }
            });

            const results = await Promise.all(promises);
            const counts = Object.fromEntries(results.map(({ username, count }) => [username, count]));
            setWishlistCounts(counts);
        };

        fetchWishlistCounts();
    }, [owners]);

    const fetchPetCountsForOwners = async (ownerIds: number[]) => {
        try {
            const countsMap: Record<number, number> = {};

            await Promise.all(ownerIds.map(async (id) => {
                try {
                    const { data } = await apiClient(`/v1/resource/pets/aggregate?primary_id=${id}`, {
                        method: 'GET'
                    }) as any;

                    countsMap[id] = data?.pets || 0;
                } catch (err) {
                    countsMap[id] = 0;
                }
            }));

            setPetCounts(countsMap);
            console.log('Pet counts:', countsMap);

        } catch (err: any) {
            setError(err.message || "Something went wrong while fetching pet counts");
        }
    };



    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (newRowsPerPage: number) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const filteredOwners = owners;

    const columns = [

        {
            key: 'serial',
            label: 'S.No',
            align: 'center',
            render: (_row: any, index: number) => page * rowsPerPage + index + 1,
        },

        {
            key: 'owner',
            label: 'Owner',
            align: 'center',
            render: (row: any) => {
                const user = row?.user;
                const firstName = user?.first_name || '';
                const lastName = user?.last_name || '';
                const initials = `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase();

                // Generate a random but consistent color based on username
                const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#f97316'];
                const colorIndex = user?.username ? user.username.charCodeAt(0) % colors.length : 0;
                const bgColor = colors[colorIndex];

                return (
                    <div className="flex items-center gap-2">
                        {user?.profile_image ? (
                            <img
                                src={user.profile_image}
                                alt={user.username || 'Owner'}
                                className="w-10 h-10 rounded-full object-cover"
                            />
                        ) : (
                            <div
                                className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold"
                                style={{ backgroundColor: bgColor }}
                            >
                                {initials || '?'}
                            </div>
                        )}
                        <span>{`${firstName} ${lastName}`.trim() || '-'}</span>
                    </div>
                );
            },
        },

        {
            key: 'petCount',
            label: 'Pet Counts',
            align: 'center',
            render: (row: any) => petCounts[row.id] ?? 0
        },
        // { key: 'city', label: 'City', align: 'center', render: (row: any) => row?.user?.address?.city || '-' },
        {
            key: 'username',
            label: 'Username',
            align: 'center',
            render: (row: any) => {
                console.log('Row data:', row);
                return row?.user?.username || '-';
            },
        },
        { key: 'Mobile', label: 'Mobile', align: 'center', render: (row: any) => row?.user?.mobile ?? '-' },
        {
            key: 'Status',
            label: 'Status',
            align: 'center',
            render: (row: any) => {
                let text = 'Inactive';
                let bgColor = '#fee2e2';
                let textColor = '#991b1b';

                if (row?.user?.is_active === 1) {
                    text = 'Active';
                    bgColor = '#d1fae5';
                    textColor = '#065f46';
                } else if (row?.user?.is_active === 2) {
                    text = 'Deactivated';
                    bgColor = '#fef3c7'; // amber background
                    textColor = '#92400e'; // amber text
                }

                return (
                    <span
                        style={{
                            backgroundColor: bgColor,
                            color: textColor,
                            padding: '4px 8px',
                            borderRadius: '6px',
                            fontWeight: 'bold',
                            display: 'inline-block',
                            minWidth: '90px',
                        }}
                    >
                        {text}
                    </span>
                );
            },
        }
        ,
    ];
    const handleOpenModal = (user: any) => {
        setCurrentUser(user);
        setModalOpen(true);
    };

    const actions = [
        {
            label: 'View',
            color: '#2196f3',
            icon: <IconEye size={20} />,
            onClick: (row: any) => handleShowDetails(row)
        },
        {
            label: 'Edit',
            color: '#4caf50',
            icon: <IconEdit size={20} />,
            onClick: (row: any) => handleEditClick(row),
        },

        {
            label: 'Change Status',
            color: '#1976d2',
            icon: <IconActivate />,
            onClick: (row: any) => handleOpenModal(row),
        },
        {
            label: 'Show Pets',
            color: '#7b1fa2',
            icon: <IconPaw size={20} />,
            onClick: (row: any) => {
                handlePet(row);
            }
        },
        // {
        //     label: 'Cart',
        //     color: '#3F51B5',
        //     icon: <IconCart size={20} />,
        //     onClick: (row: any) => { }
        // },

        {
            label: 'Manage Security',
            color: '#ff9800',
            icon: <IconShield size={20} />,
            onClick: (row: any) => {
                if (!row?.user) return;
                setSelectedUserForSecurity(row.user);
                setSecurityDialogOpen(true);
            }
        },
        // {
        //     label: 'Manage Location',
        //     color: '#009688',
        //     icon: <IconMapPin size={20} />,
        //     onClick: (row: any) => {
        //         if (!row?.user) return;
        //         setSelectedUserForLocation(row.user);
        //         setLocationDialogOpen(true);
        //     }
        // },
        {
            label: (row: any) => {
                const count = wishlistCounts[row?.user?.username] ?? '...';
                return `Wishlist (${count})`;
            },

            icon: (row: any) => {
                const count = wishlistCounts[row?.user?.username] ?? 0;
                const isActive = count > 0;
                return (
                    <Badge
                        badgeContent={count}
                        sx={{
                            '& .MuiBadge-badge': {
                                backgroundColor: 'yellow',
                                color: 'black',
                            },
                        }}
                    >
                        <AnimatedBox className={isActive ? 'active' : ''}>
                            <IconHeart
                                size={24}
                                color={isActive ? '#e53935' : '#283e51'}
                                fill={isActive ? '#e53935' : 'none'}
                            />
                        </AnimatedBox>
                    </Badge>
                )
            },

            onClick: (row: any) => {
                if (!row?.user?.username) return alert("Username not available");
                setSelectedUsername(row.user.username);
                setWishlistDialogOpen(true);
            }
        },
    ];
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setPage(0);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchInput]);

    if (loading) return <LoadingScreen message="Loading Pet Owners..." layout={false} />;


    if (error) {
        return <Typography color="error">Error: {error}</Typography>;
    }


    const handleShowDetails = (item: any) => {
        const id = item.id;

        navigate(`/pet-owners/${id}`, {
            state: { item },
        });
    };

    const handlePet = (item: any) => {

        navigate(`/users?role=Pets`, {
            state: { item },
        });
    };

    const handleSearchClick = () => {
        setSearchQuery(searchInput);
        setPage(0);
        setHasSearched(true);
    };

    const handleClearClick = () => {
        setSearchInput('');
        setSearchQuery('');
        setHasSearched(false);
    };

    const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setStatusFilter(e.target.value);
        setPage(0); // reset to first page on filter change
    };
    return (
        <>
            <Box>
                <Box
                    display="flex"
                    flexWrap="wrap"
                    gap={2}
                    mb={2}
                    alignItems="flex-end"
                >
                    {/* Pet Owner Name */}
                    <div className="flex gap-2 items-end flex-1 min-w-[320px]">
                        <div className="flex-1">
                            <label
                                className="block text-sm font-medium text-gray-700 mb-1"
                                htmlFor="ownerName"
                            >
                                Pet Owner Name
                            </label>
                            <input
                                id="ownerName"
                                type="text"
                                placeholder="Search owner name"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                className="w-full px-3 py-2 border text-gray-700 border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                            />
                        </div>

                        {hasSearched ? (
                            <button
                                onClick={handleClearClick}
                                className="h-[38px] px-4 bg-gray-500 text-white text-sm rounded-md hover:bg-gray-600"
                            >
                                Clear
                            </button>
                        ) : (
                            <button
                                onClick={handleSearchClick}
                                disabled={!searchInput.trim()}
                                className="h-[38px] px-4 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                            >
                                Search
                            </button>
                        )}
                    </div>

                    {/* Status Filter */}
                    <div className="min-w-[180px] flex flex-col">
                        <label
                            htmlFor="status-select"
                            className="block text-sm font-medium text-gray-700 mb-1"
                        >
                            Status
                        </label>
                        <select
                            id="status-select"
                            value={statusFilter}
                            onChange={handleStatusChange}
                            className="w-full px-3 py-2 border border-gray-300 text-gray-700 rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                        >
                            <option value="">All Status</option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                            <option value="2">Deactivated</option>
                        </select>
                    </div>

                    {/* Add Button */}
                    <div className="flex items-end">
                        <button
                            onClick={handleAddClick}
                            className="h-[38px] px-5 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700"
                        >
                            + Add
                        </button>
                    </div>
                </Box>

                <DynamicTable
                    columns={columns}
                    data={filteredOwners}
                    loading={loading}
                    actions={actions}
                    emptyMessage={"No Petowners found"}
                    page={page}
                    error={error}
                    rowsPerPage={rowsPerPage}
                    totalCount={totalCount}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                    ActionsComponent={TablePaginationActions}
                />

            </Box>
            <WishlistDialog
                open={wishlistDialogOpen}
                onClose={() => setWishlistDialogOpen(false)}
                username={selectedUsername}
            />
            <SecurityDialog
                open={securityDialogOpen}
                onClose={() => setSecurityDialogOpen(false)}
                user={selectedUserForSecurity}
                refreshUsers={fetchOwners}
            />
            {showAddModal && (
                <AddOwnerModal
                    mode={editData ? "edit" : "add"}
                    editData={editData}
                    onClose={() => {
                        setShowAddModal(false);
                        setEditData(null);
                    }}
                    onSuccess={() => {
                        setShowAddModal(false);
                        setEditData(null);
                        fetchOwners();
                    }}
                />
            )}
            <LocationDialog
                open={locationDialogOpen}
                onClose={() => setLocationDialogOpen(false)}
                user={selectedUserForLocation}
            />
            <StatusModal
                open={modalOpen}
                currentUser={currentUser}
                onClose={() => setModalOpen(false)}
                onUpdate={fetchOwners}
            />
            <EditChoiceDialog
                open={editChoiceOpen}
                onClose={() => setEditChoiceOpen(false)}
                onEditUser={handleOpenEditUser}
                onEditLocation={handleOpenEditLocation}
            />
        </>
    );
};

export default PetOwnerList;
